// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.description"></sub-header>

<div>
    <form name="\$ctrl.form">
      <table class="table">
        <tbody>
        <tr>
          <td>Name:</td>
          <td>
            <input type="text"
                   required
                   ng-model="\$ctrl.name"/>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Action type:</td>
          <td>
            <multiselect items="\$ctrl.availableActionTypes"
                         ng-model="\$ctrl.actionTypes"
                         label-property="'name'"
                         value-property="'value'"
                         ng-required="true"
                         ng-disabled="\$ctrl.editMode">
            </multiselect>
          </td>
          <td></td>
          <tr>
            <td>Allowed branches:</td>
            <td>
              <multiselect items="\$ctrl.allBranches"
                           ng-model="\$ctrl.allowedBranchIds"
                           label-property="'name'"
                           value-property="'id'"
                           ng-required="true"
                           select-all-option="true">
              </multiselect>
              <help title="Category will be limited to selected branches"></help>
            </td>
            <td></td>
          </tr>
        </tr>
        <tr ng-if="\$ctrl.isTargetBranchLimitAvailable()">
          <td>Target branch:</td>
          <td>
            <multiselect items="\$ctrl.allBranches"
                         ng-model="\$ctrl.selectedBranchIds"
                         label-property="'name'"
                         value-property="'id'"
                         ng-required="true"
                         select-all-option="true">
            </multiselect>
            <help title="Interbranch Cash In/Out target branch will be limited to selected branches"></help>
          </td>
          <td></td>
        </tr>
        <validator condition="\$ctrl.atLeastOneAccountSelected()"></validator>
        <div class="alert alert--danger" ng-if="!\$ctrl.atLeastOneAccountSelected()">
          At least one General Ledger account is required. Press 'Add new' to select one.
        </div>
        <div class="alert alert--danger" ng-if="\$ctrl.editMode && !\$ctrl.category">
          This category doesn't exist.
        </div>
        <tr ng-if="\$ctrl.supportsLedger" ng-repeat="account in \$ctrl.accounts">
          <td>{{\$index + 1}}.</td>
          <td>
            <field
                options="\$ctrl.ledgerAccounts"
                field="fullCode"
                ng-model="account.fullCode"
                transcluded-model="account.tmpAccount">
              <account-select options="\$ctrl.ledgerAccounts"
                              ng-model="account.tmpAccount"
                              value-field="'id'"
                              required
              >
              </account-select>
            </field>
          </td>
          <td>
            <button type="button"
                    class="btn btn-danger"
                    ng-click="\$ctrl.removeAccount(\$index)">
              Remove
            </button>
          </td>
        </tr>

        <tr>
          <td colspan="2">
          </td>
          <td>
            <button type="button" class="btn btn-success" ng-click="\$ctrl.addNewAccount()">Add new</button>
          </td>
        </tr>
        </tbody>
      </table>
    </form>

  <div class="clearfix"></div>

  <div class="summary-actions">
    <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.cancel()">
      Cancel
    </button>
    <button
        type="submit"
        class="btn btn-success"
        ng-disabled="\$ctrl.form.\$invalid"
        ng-click="\$ctrl.save()">
      Save
    </button>
  </div>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/transactions/transactions-category-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;